import { get, patch, post, put } from './client';
import type { ApiResult } from './types';

export interface NewsCategory {
    category_id: number;
    label: string;
    type: 'STORIES';
    url_identifier: string;
    rank: number | null;
    count: number;
    is_enabled: boolean;
}

export interface NewsCategoryInput {
    label: string;
    url_identifier?: string;
    rank?: number | null;
}

const BASE_URL = '/admin/news-categories';

export function getNewsCategories(): Promise<ApiResult<NewsCategory[]>> {
    return get<NewsCategory[]>(BASE_URL);
}

export function addNewsCategory(
    data: NewsCategoryInput
): Promise<ApiResult<NewsCategory>> {
    return post<NewsCategory>(BASE_URL, data);
}

export function updateNewsCategory(
    categoryId: number,
    data: NewsCategoryInput
): Promise<ApiResult<NewsCategory>> {
    return put<NewsCategory>(`${BASE_URL}/${categoryId}`, data);
}

export function setNewsCategoryStatus(
    categoryId: number,
    isEnabled: boolean
): Promise<ApiResult<NewsCategory>> {
    return patch<NewsCategory>(`${BASE_URL}/${categoryId}/status`, {
        is_enabled: isEnabled
    });
}
